import { render } from "./DocumentsFormulaires.vue?vue&type=template&id=76af12b4"
import script from "./DocumentsFormulaires.vue?vue&type=script&lang=js"
export * from "./DocumentsFormulaires.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__